<template>    
    <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.17318 4.98633V11.653H2.83984V4.98633H8.17318ZM7.17318 0.986328H3.83984L3.17318 1.65299H0.839844V2.98633H10.1732V1.65299H7.83984L7.17318 0.986328ZM9.50651 3.65299H1.50651V11.653C1.50651 12.3863 2.10651 12.9863 2.83984 12.9863H8.17318C8.90651 12.9863 9.50651 12.3863 9.50651 11.653V3.65299Z" fill="#2F80ED"/>
    </svg>
</template>    